import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = localStorage.getItem('access_token_obgrm');

    let authReq = req;

    //  Ajouter le token si présent
    if (token) {
      authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {

        //  Si 401 → redirection login
        if (error.status === 401) {
          localStorage.removeItem('access_token_obgrm'); // optionnel mais recommandé
          this.router.navigate(['/login']);
        }

        return throwError(() => error);
      })
    );
  }
}
